import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarRef, MatSnackBarAction, MatSnackBarActions } from '@angular/material/snack-bar';

@Component({
  selector: 'faxe-update-snackbar',
  templateUrl: './update-snackbar.component.html',
  styleUrls: ['./update-snackbar.component.scss'],
  imports: [MatButtonModule, MatSnackBarAction, MatSnackBarActions],
  standalone: true
})
export class UpdateSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);

  onUpdate(): void {
    this.snackBarRef.dismissWithAction();
  }
}
